/* eslint-disable react-hooks/exhaustive-deps */
import { capitalize } from "lodash";
import {
  useEffect
} from "react";
import { Outlet, useParams } from "react-router-dom";
import { useAccount, useAccountContacts } from "../../../hooks/QueryHooks";
import useWorkspaceStore from "../../../store/workspace/workspaceStore";
import ProfileHeader from "./components/AccountProfileHeader";
import AccountRoutes from "./components/AccountRoutes";
import { ScrollArea } from "@mantine/core";

const AccountDetailsPage = () => {
  const { accountId }: any = useParams();
  const workspaceId = useWorkspaceStore((state) => state.workspace?.id);

  const accountData: any = useAccount({
    workspaceId,
    accountId,
    enabled: accountId !== "",
  });
  const contacts: any = useAccountContacts({
    workspaceId,
    accountId,
    enabled: accountId !== "",
  });

  useEffect(() => {
    if (accountData?.data?.name) {
      document.title = `${accountData?.data.name ? `${capitalize(accountData?.data.name)} | ` : ""}Account | Hyperengage`;
    }
  }, [accountData?.data?.name]);

  return (
    <div className="flex min-h-full bg-gray-50 p-0">
      {/* Left column - fixed width for header information */}
      <div 
        className="w-[320px] shrink-0 border-r border-gray-200 overflow-y-auto h-full bg-white"
      >
        <ScrollArea type="scroll" scrollHideDelay={500} h="calc(100vh - 80px)" className="p-4">
          <ProfileHeader contacts={contacts?.data?.items} key={accountId} account={accountData?.data} />
        </ScrollArea>
      </div>
      
      {/* Right column - flexible width for outlet content */}
      <div className="flex-grow overflow-y-auto h-full">
        <div className="sticky top-0 bg-gray-50 z-10">
          <AccountRoutes />
        </div>
        <div className="p-3">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AccountDetailsPage;
